module.exports = __webpack_public_path__ + "static/media/tennis_court.c9402731.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/tennis_court.svg
// module id = 1541
// module chunks = 0